var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 24C32.6153 23.0898 30.2605 19.5 29 19.5C27.7395 19.5 25.3847 23.0898 24.5 24M29 21V31.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0052 31.5H18.504C11.4311 31.5 7.89459 31.5 5.6973 29.3032C3.5 27.1066 3.5 23.571 3.5 16.5V11.9164C3.5 9.1917 3.5 7.82934 4.07063 6.80709C4.4774 6.07841 5.07883 5.47713 5.80772 5.07048C6.83026 4.5 8.19298 4.5 10.9184 4.5C12.6645 4.5 13.5376 4.5 14.3018 4.78651C16.0467 5.44068 16.7663 7.02537 17.5536 8.59969L18.504 10.5M12.5024 10.5H25.631C28.7919 10.5 30.3724 10.5 31.5077 11.2584C31.9993 11.5867 32.4212 12.0086 32.7496 12.4999C33.3406 13.3842 33.4712 14.5387 33.5 16.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3c386ad63323f5401279dc8558f6ba10.svg";
export { ForwardRef as ReactComponent };